import { render, staticRenderFns } from "./forgot-old.vue?vue&type=template&id=17a16f56&scoped=true"
import script from "./forgot-old.vue?vue&type=script&lang=js"
export * from "./forgot-old.vue?vue&type=script&lang=js"
import style0 from "./forgot-old.vue?vue&type=style&index=0&id=17a16f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a16f56",
  null
  
)

export default component.exports